import cn from 'clsx'
import { CopyLinkInput } from '@tracklib/kit'
import styles from './status.css'

const SharingStatus = ({ status, beatId }: { status: string; beatId: number }): JSX.Element => (
  <div className={cn(styles.wrapper, status === 'private' ? styles.negative : styles.positive)}>
    <p className={styles.label}>Sharing Status</p>
    <p className={styles.title}>{status === 'private' ? 'No sharing allowed' : 'Limited sharing allowed'}</p>
    <p className={styles.description}>
      {status === 'private'
        ? 'You cannot share your song anywhere. You can fill the details in the form below and change the visibility to unlisted or public in order to share your beat on Tracklib.'
        : 'Your beat can be shared on Tracklib using the link below. In order to release your song you need to buy a sample license.'}
    </p>
    {beatId && (status === 'public' || status === 'unlisted') && <CopyLinkInput path={`/beat/${beatId}/`} className={styles.input} />}
  </div>
)

export default SharingStatus
